export const LPC_STRINGS_MODULE_NAME = 'owa-mini-lpc-strings';
export const SAMPLE_LPC_STRING_KEY = 'newContactHeaderText';
